import { render, staticRenderFns } from "./ApplicationRoot.vue?vue&type=template&id=8e08a068"
import script from "./ApplicationRoot.vue?vue&type=script&lang=ts"
export * from "./ApplicationRoot.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationRoot.vue?vue&type=style&index=0&id=8e08a068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports